// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 126) return "static/chunks/swiper-fc104530-b625c6685fe94595.js";
	if (chunkId === 772) return "static/chunks/swiper-6391b56b-910a2e3cfb1c2797.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"0":"charts-f36d2484","721":"charts-b179dd76"}[chunkId] || chunkId) + "." + {"0":"0f026285ab211858","100":"bbf8aad2c8e0d2b3","185":"0efe088577157c2a","439":"e80117b29f216f34","637":"112bfb8c13d2288b","721":"0b28c7a3d59f7c26"}[chunkId] + ".js";
};